//是否是本地开发环境
export const isDev = location.href.indexOf('http://localhost') === 0 || location.href.indexOf('http://192.168.10.84:7072') === 0 || location.href.indexOf('http://127.0.0.1') === 0;
// 是否是测试环境
export const isTesting = location.href.indexOf('.kf315.net') >= 0;
// 是否是生产环境
export const isProduction = !(isDev || isTesting);

// 测试环境设置
const testConfig = {
  //
  organizationId: '86ff1c47b5204e88918cb89bbd739f12',
  h5Domain: 'https://freedom.h5.kf315.net/sites/BanMuHuaTian/index.html'
};
// 本地开发设置
const devConfig = {
  organizationId: '86ff1c47b5204e88918cb89bbd739f12',
  h5Domain: 'https://freedom.h5.kf315.net/sites/BanMuHuaTian/index.html'
};
// 生产环境设置
const productionConfig = {
  //
  organizationId: '7091d8d2f0ef4368bce0f1349a10c001',
  h5Domain: 'https://freedom.jgwcjm.com/sites/BanMuHuaTian/index.html'
};
//
let config = {};
if (isDev) {
  config = devConfig;
} else if (isTesting) {
  config = testConfig;
} else if (isProduction) {
  config = productionConfig;
}
const finalConfig = {
  ...config
};
export default finalConfig;
